var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGlobalImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-316 -540)"
  }, /*#__PURE__*/React.createElement("circle", {
    fill: "#5d78ff",
    opacity: 0.3,
    cx: 8,
    cy: 8,
    r: 8,
    transform: "translate(316 540)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#5d78ff",
    d: "M3.711-7.14a3.341,3.341,0,0,1,2.072.615A2.62,2.62,0,0,1,6.8-4.86H5.083a1.321,1.321,0,0,0-.52-.572,1.591,1.591,0,0,0-.842-.213,1.574,1.574,0,0,0-1.23.516,2.01,2.01,0,0,0-.464,1.4,2.043,2.043,0,0,0,.487,1.467A1.825,1.825,0,0,0,3.9-1.756a1.674,1.674,0,0,0,1.012-.317,1.689,1.689,0,0,0,.615-.9H3.484V-4.141h3.4v1.6a3.262,3.262,0,0,1-.606,1.088A3.118,3.118,0,0,1,5.21-.64,3.371,3.371,0,0,1,3.73-.327,3.518,3.518,0,0,1,1.96-.758,2.949,2.949,0,0,1,.792-1.964,3.718,3.718,0,0,1,.38-3.734,3.718,3.718,0,0,1,.792-5.5,2.958,2.958,0,0,1,1.955-6.709,3.472,3.472,0,0,1,3.711-7.14Z",
    transform: "translate(320.37 552)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGlobalImage);
export default __webpack_public_path__ + "static/media/global-image.a4766c88c6d5ded69c3e0a93132a7e87.svg";
export { ForwardRef as ReactComponent };